import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';
import { LanguageService } from '@core/services/language.service';
import { ToastContainerComponent } from '@shared/components/toast/toast-container.component';
import { environment } from '@env';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly theme = inject(ThemeService);
  private readonly language = inject(LanguageService);
  readonly isProd = environment.production;
  readonly envName = environment.envName.toUpperCase();
}